<template>
    <b-modal
        @ok="generateReport"
        class="pt-8"
        v-model="showModal"
        title="Select Report Type"
    >
        <template #default>
            <b-form class="mt-3">
                <b-form-group label="Report Types" v-slot="{ ariaDescribedby }">
                    <b-form-radio
                        v-model="reportType"
                        :aria-describedby="ariaDescribedby"
                        name="reportTypeGroup"
                        value="detail_report"
                        id="detail_report"
                        >Order Detail Report PDF</b-form-radio
                    >
                    <b-form-radio
                        v-model="reportType"
                        :aria-describedby="ariaDescribedby"
                        name="reportTypeGroup"
                        value="statement"
                        id="statement"
                        >Order Statement PDF</b-form-radio
                    >
                    <b-form-radio
                        v-model="reportType"
                        :aria-describedby="ariaDescribedby"
                        name="reportTypeGroup"
                        value="include_pricing"
                        id="include_pricing"
                        >Order Statement-Pricing PDF</b-form-radio
                    >
                    <b-form-radio
                        v-model="reportType"
                        :aria-describedby="ariaDescribedby"
                        name="reportTypeGroup"
                        value="summary_report"
                        id="summary_report"
                        >Order Summary Report PDF</b-form-radio
                    >
                    <b-form-radio
                        v-model="reportType"
                        :aria-describedby="ariaDescribedby"
                        name="reportTypeGroup"
                        value="detail_export"
                        id="detail_export"
                        >Order Detail Report Excel</b-form-radio
                    >
                    
                    <b-form-radio
                        v-model="reportType"
                        :aria-describedby="ariaDescribedby"
                        name="reportTypeGroup"
                        value="pdf_service_summary"
                        id="pdf_service_summary"
                        >Billing Summary Report PDF</b-form-radio
                    >
                    <b-form-radio
                        v-model="reportType"
                        :aria-describedby="ariaDescribedby"
                        name="reportTypeGroup"
                        value="summary_export"
                        id="summary_export"
                        >Billing Summary Report Excel</b-form-radio
                    >
                    <b-form-radio
                        v-model="reportType"
                        :aria-describedby="ariaDescribedby"
                        name="reportTypeGroup"
                        value="officer_details"
                        id="officer_details"
                        >Officer Summary Report</b-form-radio
                    >
                    <b-form-radio
                        v-model="reportType"
                        :aria-describedby="ariaDescribedby"
                        name="reportTypeGroup"
                        value="service_billing_pdf"
                        id="service_billing_pdf"
                        >Billing Detailed Report PDF</b-form-radio
                    >
                    <b-form-radio
                        v-model="reportType"
                        :aria-describedby="ariaDescribedby"
                        name="reportTypeGroup"
                        value="service_billing_excel"
                        id="service_billing_excel"
                        >Billing Detail Report Excel</b-form-radio
                    >
                    <b-form-radio
                        v-model="reportType"
                        :aria-describedby="ariaDescribedby"
                        name="reportTypeGroup"
                        value="customer_order_excel"
                        id="customer_order_excel"
                        >Order-Customer Report Excel</b-form-radio
                    >  
                    <b-form-radio
                        v-model="reportType"
                        :aria-describedby="ariaDescribedby"
                        name="reportTypeGroup"
                        value="officer_order_excel"
                        id="officer_order_excel"
                        >Order-Officer Report Excel</b-form-radio
                    >
                    <b-form-radio
                        v-model="reportType"
                        :aria-describedby="ariaDescribedby"
                        name="reportTypeGroup"
                        value="order_header"
                        id="order_header"
                        >Order-Header Report Excel</b-form-radio
                    >
                </b-form-group>

                <b-form-group
                    v-show="reportType === 'detail_report'"
                    label="Select Options"
                    v-slot="{ ariaDescribedby }"
                >
                    <b-form-checkbox
                        v-for="option in rpt_options_props"
                        v-model="rpt_options[option.key]"
                        :key="option.text"
                        :value="option.value"
                        :aria-describedby="ariaDescribedby"
                        name="rpt_optionS_name"
                    >
                        {{ option.text }}
                    </b-form-checkbox>
                </b-form-group>
            </b-form>
        </template>

        <template #modal-footer="{ ok, cancel }">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <b-button
                size="sm"
                :disabled="!reportType"
                variant="success"
                @click="ok()"
            >
                <b-spinner
                    small
                    v-show="report_loading"
                    variant="primary"
                    label="Spinning"
                ></b-spinner>
                <span v-if="hasPermissionCreate" v-show="!report_loading"
                    >Create Report</span
                >
            </b-button>
            <b-button size="sm" variant="danger" @click="cancel()">
                Cancel
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import reportMixins from '@/mixins/reportMixins'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'reports-exportDetails',
    mixins: [popupMixins, permissionsMixins, reportMixins],
    data() {
        return {
            showModal: false,
            reportType: null,

            rpt_options_props: [
                {
                    value: true,
                    key: 'includeAttachments',
                    text: 'include Attachment',
                },
                { value: true, key: 'includeTasks', text: 'Include Tasks' },
                { value: true, key: 'includeNotes', text: 'include Notes' },
            ],

            rpt_options: {
                includeAttachments: true,
                includeTasks: true,
                includeNotes: true,
                includeAuditLogs: false,
            },
        }
    },
    props: ['queryData'],
    computed: {
        compositeQuery() {
            const { queryData, reportType: rpt_type, rpt_options } = this
            return {
                rpt_type,
                ...queryData,
                ...{ rpt_options },
            }
        },
    },

    watch: {
        showModal: function () {
            this.reportType = null
        },
    },
    methods: {
        show() {
            this.showModal = true
        },
        close() {
            this.showModal = false
        },

        getQueryString() {
            return `&query=${btoa(JSON.stringify(this.compositeQuery))}`
        },
    },
}
</script>

<style scoped>
</style>